import { Component, OnInit } from '@angular/core';
import { LeadsService } from '../_service/leads.service';
import { MemberService } from '../_service/member.service';
import { SharedService } from '../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-member-add-insurance-transaction',
  templateUrl: './member-add-insurance-transaction.component.html',
  styleUrls: ['./member-add-insurance-transaction.component.css']
})
export class MemberAddInsuranceTransactionComponent implements OnInit {
  transactionForm: FormGroup;loading:boolean=false;myrole:string;loaded:boolean=false;cities=[];cities_copy=[];payment_mode=[];package_type=[];submitted:boolean=false;memberBds = []; memberBds_copy = [];
  constructor(private formBuilder: FormBuilder, private memberapi:MemberService, private leadapi:LeadsService,private sharedapi:SharedService,private router:Router, private route:ActivatedRoute) { 
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
    this.transactionForm = this.formBuilder.group({ 
      'name' : [null, Validators.required],
      'email' : [null],
      'mobile' : [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
      'city_id' : [null],
      'package_type' : [null, Validators.required],
      'payment_mode' : [null, Validators.required],
      'order_id' : [null],
      'payment_id' : [null],
      'amount' : [null],
      'transaction_date' : [null, Validators.required],
      'memberBd' : [null]
    });
    this.payment_mode=[
      {
        'value':'razorpay',
        'name':'Razorpay',
      },
      {
        'value':'paytm',
        'name':'Paytm',
      },
      {
        'value':'gpay',
        'name':'Gpay',
      },
      {
        'value':'cash',
        'name':'Cash',
      },
      {
        'value':'phonepay',
        'name':'Phonepay',
      }
    ];
  }

  ngOnInit(): void {
    this.getcitiesList();
    this.getPackageTypeList();
    this.getMemberBds();
  }

  get f() { return this.transactionForm.controls; }

  setSearchValue(type){
    if(type=='city'){
        $("#citySearch").val('');
        $("#citySearch").focus();
        this.cities= this.cities_copy;
    }else if(type=='bd'){
      $("#bdSearch").val('');
      $("#bdSearch").focus();
      this.memberBds= this.memberBds_copy;
    }
}

searchOnSelect(searchtText: string, type){
    if (type == 'city') {
        this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
    }else if(type == 'bd'){
      this.memberBds = this.sharedapi.searchData(searchtText, this.memberBds_copy, "name");
    }
}

  async getcitiesList()
  {
    await this.leadapi.getcities().subscribe((data:any) => {
        if(data.status)
        {
            this.cities = data.data;
            this.cities_copy= this.cities;
        }else{
            this.cities = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async getPackageTypeList()
  {
    await this.memberapi.getPackageType().subscribe((data:any) => {
        if(data.status)
        {
            this.package_type = data.data;
        }else{
            this.package_type = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async saveTransactionData(){
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.transactionForm.invalid) {
        this.loading = false;
        return;
    }
    
    await this.memberapi.addTransactionData(this.transactionForm.value)
     .subscribe((data:any) => {
      this.submitted = false;
      this.loading = false;
      console.log(data);
      if(data.status)
      {
        this.router.navigateByUrl('/members');
        this.sharedapi.presentToast("Member's Transaction Added Successfully");
      }
      else
      {
          this.sharedapi.presentToast(data.msg);
      }
    }, error => 
    {
        this.sharedapi.checkError(error);
    }); 
}

async getMemberBds() {
  await this.memberapi.getMemberBds().subscribe((data: any) => {
      if (data.status) {
          this.memberBds = data.data;
          this.memberBds_copy = this.memberBds;
      } else {
          this.memberBds = [];
      }
  }, error => {
      this.sharedapi.checkError(error);
  });
}

}
